import { createAction } from '@reduxjs/toolkit';
import { IResource } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_RESOURCES } from '../../../../common';

export const setResources = createAction<IResource[]>(
  `${MN_RESOURCES}/${TYPE_LIST}/${ACT_SET}`,
);
